import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset, authenticateSigner, signDocument } from '../../redux/actions/SignerAction';
import Loading from '../Loader/Loader';
import ErrorPage from '../Error/ErrorPage';
import '../../assets/style/SignDocument.css';

const EmailAuthentication = (props) => {
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [codeMismatchError, setCodeMismatchError] = useState(false);
  const [encodedString, setEncodedString] = useState('');
  const [genericError, setGenericError] = useState(false);
  const [emailTouched, setEmailTouched] = useState(false);
  const {
    isSignerAuthenticated,
    isDocumentSigned,
    fetching,
    error,
    t,
    reset
  } = props;

  useEffect(() => {
    reset();
    const urlParams = new URLSearchParams(window.location.search);
    const decodedValue = decodeURIComponent(urlParams.get('id'));
    setEncodedString(decodedValue);
  }, [reset]);


useEffect(() => {
  if (isSignerAuthenticated && Object.keys(isSignerAuthenticated).length > 0) {
    setIsValidEmail(isSignerAuthenticated.IsEmailAuthorized);
    setVerificationCode(isSignerAuthenticated.Code);
  }
  if (isDocumentSigned === true) {
    window.location = `/signingresult`;
  } else if (isDocumentSigned === false) {
    setGenericError(true);
  }
}, [isSignerAuthenticated, isDocumentSigned]);

  const handleChange = (event) => {
    props.reset();
    const emailValue = event.target.value;
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);

    setEmail(emailValue);
    setIsValidEmail(isValid);
    setEmailTouched(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isValidEmail) {
      props.authenticateSigner(encodedString, email);
    }
  };

  const handleVerification = (event) => {
    event.preventDefault();
    const enteredCode = event.target.code.value;

    if (verificationCode === enteredCode) {
      setCodeMismatchError(false);
      props.signDocument(encodedString);
    } else {
      setCodeMismatchError(true);
    }
  };



  return (
    <div className="auth-container">
      {fetching && !error && <Loading />}

      {error || genericError ? (
        <ErrorPage />
      ) : (
        <div className="auth-wrapper">
          <div className="auth-card">
            <div className="auth-header">
              <div className="auth-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <h2>{t('emailsigning.emailVerificationTitle')}</h2>
              <p className="auth-subtitle">{t('emailsigning.emailVerificationmsg')}</p>
            </div>

            <form autoComplete="off" onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  {t('emailsigning.emailAddresslabel')}
                </label>

                <input
                  type="email"
                  id="email"
                  className={`form-input ${emailTouched ? (isValidEmail ? 'valid' : 'invalid') : ''}`}
                  value={email}
                  onChange={handleChange}
                  placeholder="name@example.com"
                />

                {emailTouched && !isValidEmail && (
                  <div className="error-message">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" stroke="white" strokeWidth="2" />
                      <line x1="12" y1="16" x2="12.01" y2="16" stroke="white" strokeWidth="2" />
                    </svg>
                    <span>{t('emailsigning.validemailaddressmsg')}</span>
                  </div>
                )}
              </div>

              <button type="submit" className="btn-primary" disabled={!isValidEmail}>
                <span>{t('emailsigning.verificationCodebuttonmsg')}</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
            </form>

            {verificationCode && (
              <div className="verification-section">
                <div className="verification-divider">
                  <span>{t('emailsigning.codeSentmsg')}</span>
                </div>

                <form autoComplete="off" onSubmit={handleVerification} className="auth-form">
                  <div className="form-group">
                    <label htmlFor="code" className="form-label">
                      {t('emailsigning.verificationCodelabelmsg')}
                    </label>

                    <input
                      type="text"
                      id="code"
                      name="code"
                      className={`form-input verification-input ${codeMismatchError ? 'invalid' : ''}`}
                      placeholder={t('emailsigning.entercodemsg')}
                      maxLength="5"
                      required
                    />

                    {codeMismatchError && (
                      <div className="error-message">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <circle cx="12" cy="12" r="10" />
                          <line x1="12" y1="8" x2="12" y2="12" stroke="white" strokeWidth="2" />
                          <line x1="12" y1="16" x2="12.01" y2="16" stroke="white" strokeWidth="2" />
                        </svg>
                        <span>{t('emailsigning.confirmationsentmsg')}</span>
                      </div>
                    )}
                  </div>

                  <button type="submit" className="btn-primary">
                    <span>{t('emailsigning.verifycontinuemsg')}</span>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </button>
                </form>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isSignerAuthenticated: state.sign.isSignerAuthenticated,
  isDocumentSigned: state.sign.isDocumentSigned,
  fetching: state.sign.fetching,
  error: state.error.isError,
});

export default connect(mapStateToProps, {
  reset,
  authenticateSigner,
  signDocument
})(withTranslation('common')(EmailAuthentication));